module.exports = __webpack_public_path__ + "img/AnnetteBellamy-GretheSørensen.fe6e827b.jpg";